import React from 'react'
import ReactToPrint from "react-to-print";

const NoteRec = (props) => {
    const componentRef = React.createRef();
    return (
        <>
             <div className="note__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />
                <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                    <div>
                        <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                            <div>

                                <img  src={props.companylogo} alt="logo" />
                            </div>
                        </div>
                        <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                                <p>Delivery Note</p>
                            </article>

                            <div className=" flex justify-between my-5">
                                <article className=" flex items-start justify-start">
                                    <ul>
                                        <li className="p-1 ">
                                            <span className="font-bold">Customer's name:</span> {props.Clientname}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Customer's ID:</span> {props.clientID}
                                        </li>
                                        <li className="p-1">
                                            <span className="font-bold">Address:</span> {props.clientAddress}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Phone:</span> {props.ClientPhone}
                                        </li>
                                    </ul>
                                </article>
                                <article className=" flex items-end justify-end">
                                    <ul>
                                        <li className="p-1 ">
                                            <span className="font-bold">Delivery Note number:</span> {props.notenumber}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Delivery Note date:</span> {props.noteDate}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Time:</span> {props.time}
                                        </li>
                                        {props.clientLpo && (
                                            <li className="p-1 ">
                                                <span className="font-bold">LPO No:</span> {props.clientLpo}
                                            </li>
                                        )}
                                    </ul>
                                </article>
                            </div>
                            <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">S.No.</td>
                                        <td className="font-bold">Item Code</td>
                                        <td className="font-bold">Description</td>
                                        <td className="font-bold">UOM</td>
                                        <td className="font-bold">Quantity</td>
                                        <td className="font-bold">Delivered Qty</td>
                                        {/* <td className="font-bold">Price</td> */}
                                        {/* <td className="font-bold">Total</td> */}
                                    </tr>
                                </thead>
                                {props.list?.map(({ id,itemcode, itemdesc, quantity, delQuantity, price, amount, uom }, index) => (
                                    <React.Fragment key={id}>
                                        <tbody>
                                            <tr className=" text-center h-10">
                                                <td>{index + 1}</td>
                                                <td>{itemcode}</td>
                                                <td>{itemdesc}</td>
                                                <td>{uom}</td>
                                                <td>{quantity}</td>
                                                <td>{delQuantity}</td>
                                                {/* <td>{price}</td> */}
                                                {/* <td>{amount}</td> */}
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                ))}
                            </table>

                        {/* <div className=" flex flex-col gap-2">
                                <h2 className="flex items-end justify-end text-gray-800 text-2xl font-bold ">
                                   Net Total: QAR {props.total.toLocaleString()} 
                                </h2>
                            </div> */}
                    </div>
                    {props.notes &&                        
                            <section className="mt-10 mb-5">
                                <h3>Additional notes</h3>
                                <p className="lg:w-1/2 text-justify">{props.notes}</p>
                            </section>
                        }
                        <footer className= " footer border-t-2 border-gray-300 pb-5">
                        <div className=" w-full flex justify-evenly pt-4 pb-20 px-5 border-b border-gray-300 mb-2 text-base">
                                <p>Prepared By</p>
                                <p>Approved By</p>
                                <p>Delivered By</p>
                                <p className=" ">Reciever's Name, Signature & Contact No. </p>

                            </div>
                            <ul className="flex flex-wrap items-center gap-2 justify-center">
                                <li>
                                    <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                                </li>
                                <li>
                                    <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                                </li>
                                <li>
                                    <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                                </li>
                            </ul>
                            <p className="text-center px-5 mt-4 text-xs ">
                            Thankyou for your purchase!
                        </p>
                        </footer>

                </div>
            </div>
        </>
    )
}

export default NoteRec